module.exports = __webpack_public_path__ + "img/dv_line2.f06a1355.png";